// **************************
// *** MeusAgendamentos (em aberto) pc_abertos.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 16/10/24 | 14h46 → versão 1
// **************************

import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from "../../../../Services/apiaxios.js";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import handleApiError from "../../../../Services/apiErrorHandler.js";
import { pc_getUserData } from "../../Services/pc_userutils.js";

import PCMenu from '../../Components/Menu/pc_menu.jsx';
import { AutoLogout } from "../../../../Services/autologout.js";
import CardAgendamentos from '../../../AgendexPrestador/Components/Agendamentos/p_agendamentos.jsx';
import Footer from "../../../AgendexCliente/components/Footer/footer.jsx";

import './pc_agendamentos.css';

function PCMeusAgendamentos() {
    const tokenASW = localStorage.getItem("tokenasw");
    const tokenLG = localStorage.getItem("tokenlg");
    useEffect(() => {
        if (!tokenASW || !tokenLG) {
            AutoLogout();
        }
    }, [tokenASW, tokenLG]);

    const initialUserData = pc_getUserData();
    const [id_usuario, setId_usuario] = useState(initialUserData.userId); // id_usuario logado 23/9/24w
    const [tamanho_pagina, setTamanho_pagina] = useState(initialUserData.TAMANHO_PAGINA); // id_usuario logado 23/9/24w
    const [id_colaborador, setId_colaborador] = useState(initialUserData.colaboradorId); // id_usuario logado 23/9/24w
    const [nenhumAgendamentoEncontrado, setNenhumAgendamentoEncontrado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [agendamentos, setAgendamentos] = useState([]);
    const [pagina, setPagina] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const MySwal = withReactContent(Swal);
    const tipoAtendimento = 1;

    useEffect(() => {
        atualizarAgendamentosColaborador(id_colaborador, pagina);
    }, [id_colaborador, pagina]);
    
    // tipoAtendimento === 1 (busca agendamentos dos colaboradores) 23/9/24w
    const atualizarAgendamentosColaborador = async (id_colaborador, pagina) => {
        // console.log('atualizando após exclusão / id_col , pag', id_colaborador, pagina);
        setLoading(true);
        setAgendamentos([]);
        const url = `reserva/listarColaboradorWeb?id_usuario=${id_usuario}&pagina=${pagina}&tamanho_pagina=${tamanho_pagina}&id_status1=1&token=${tokenASW}&id_colaborador=${id_colaborador}`;
        try {
            const response = await apiaxios.get(url);
            // setLoading(false);

            if (response.data.retorno) {
                Swal.fire('Erro', 'Erro ao carregar agendamentos: ' + response.data.retorno, 'error');
            } else {
                if (response.data.length === 0) {
                    setNenhumAgendamentoEncontrado(true);
                    MySwal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        icon: 'info',
                        title: 'Nenhum agendamento em aberto, encontrado neste momento...'
                    });
                    setHasMore(false);
                } else {
                    setNenhumAgendamentoEncontrado(false);
                    // console.log(`response data ao trocar colaborador: ${id_colaborador} `, response.data);
                    setAgendamentos(prevDados => [...prevDados, ...response.data]);
                    if (response.data.length < tamanho_pagina) {
                        setHasMore(false);
                    }
                }
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleExcluir = (agendamento) => {
        // console.log ('dentro do handleExcluir no início array "agendamento:" ', agendamento, agendamento.agendamento_id);
        const ID_RESERVA = agendamento.agendamento_id;
        const DATA_RESERVA_STRING = agendamento.agendamento_data;

        const [datePart, timePart] = DATA_RESERVA_STRING.split(' ');
        const [day, month, year] = datePart.split('/');
        const [hours, minutes, seconds] = timePart.split(':');
        const DATA_RESERVA = new Date(year, month - 1, day, hours, minutes, seconds);

        const dataAtual = new Date();

        if (!dataAtual) {
            console.error('Erro: dataAtual está indefinido');
            return;
        }

        if (DATA_RESERVA < dataAtual) {
            Swal.fire('Atenção', 
                        'Prazo para exclusão vencido. Agendamento em análise!', 
                        'warning');
                return;
        } else if (DATA_RESERVA.toDateString() === dataAtual.toDateString() && 
            dataAtual.getHours() >= DATA_RESERVA.getHours() - 2) {
            Swal.fire('Atenção', 
                        'Prazo para exclusão vencido. Não falte ao compromisso com o prestador de serviços!',
                        'warning');
                return;
        } else if (DATA_RESERVA.toDateString() === dataAtual.toDateString() && 
            dataAtual.getHours() >= DATA_RESERVA.getHours() && 
            dataAtual.getHours() < DATA_RESERVA.getHours() + 3) {
            Swal.fire('Atenção', 
                        'Prazo para exclusão vencido. Você já deve estar dentro do atendimento!', 
                        'warning');
                return;
        }

        Swal.fire({
            title: 'Excluir Agendamento',
            html: `
                <label for="motivo">Motivo do Cancelamento:</label>
                <textarea id="motivo" class="swal2-textarea" placeholder="Digite o motivo" minlength="10"></textarea>
                <p>ID_RESERVA: ${ID_RESERVA}</p>
                <p>Data/Hora exclusão: ${dataAtual.toLocaleString()}</p>
            `,
            showCancelButton: true,
            confirmButtonText: 'Excluir',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const motivo = Swal.getPopup().querySelector('#motivo').value;
                if (!motivo || motivo.length < 10) {
                    Swal.showValidationMessage('Para cancelar seu agendamento, você precisa primeiro dizer o motivo (mínimo 10 caracteres)');
                    return false;
                }
                return motivo;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const motivo = result.value;
                // const id_usuario = JSON.parse(localStorage.getItem("tokenapw")).id_usuario;
                setLoading(true)

                // tipoAtendimento===1
                    apiaxios.put('reserva/excluirColaboradorWeb', {
                        id_reserva: ID_RESERVA,
                        tipo_exclusao: 'P',
                        id_usuario,
                        obs_cancel: motivo
                    }, {params: {id_usuario, token: tokenASW}})
                    .then(response => {
                        if (response.status === 200 && response.data.retorno === "OK") {
                            Swal.fire('Exclusão!', 'Agendamento foi excluído com sucesso.', 'success');
                            // setAgendamentos(agendamentos.filter(a => a.ID_RESERVA !== agendamento.ID_RESERVA));
                            // setAgendamentos(agendamentos.filter(a => a.agendamento_id !== agendamento.agendamento_id));
                            // setAgendamentos(agendamentos.filter(a => a.agendamento_id !== agendamento.agendamento_id));
                            // setAgendamentos(agendamentos.filter(a => a.agendamento_id !== ID_RESERVA));
                            // setAgendamentos(prevAgendamentos => prevAgendamentos.filter(a => a.agendamento_id !== ID_RESERVA));
                            // setAgendamentos(agendamentos.filter(a => a.agendamento_id !== ID_RESERVA));
                             // Filtra o array de agendamentos, excluindo o item com o ID_RESERVA correspondente
                            const novosAgendamentos = agendamentos.filter(a => a.ID_RESERVA !== ID_RESERVA);

                            // Log para verificar o array atualizado
                            // console.log('Atualizando agendamentos:', novosAgendamentos);

                            // Atualiza o estado de agendamentos com o novo array filtrado
                            setAgendamentos(novosAgendamentos);
                            // console.log('Atualizando agendamentos: ', agendamentos);
                        } else {
                            Swal.fire('Erro', response.data.retorno || 'Erro ao excluir agendamento', 'error');
                        }
                    })
                    .catch(error => {
                        Swal.fire('Erro', 'Erro ao excluir agendamento: ' + error, 'error');
                    }).finally (
                        setLoading(false)
                    );
            }
        });
    };



    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <PCMenu page="agendamentosabertos" />
                        </div>
                        <div className="col py-2 me-3">
                                <div className="form-group">
                                    <h1 className="text-center">Agendamentos Abertos / Colaborador</h1>
                                    <hr />

                                    <div className="row">
                                        {loading && (
                                            <div className="loading-spinner-container">
                                                <Oval color="#00BFFF" height={80} width={80} />
                                            </div>
                                        )}
                                        {nenhumAgendamentoEncontrado ? (
                                            <div className="alert alert-danger mt-10" role="alert">
                                                Nenhum "Agendamento em Aberto" disponível neste momento...
                                            </div>
                                        ) : (
                                            <div className="box-agendamentos">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Id.Reserva</th>
                                                            <th>Descrição</th>
                                                            <th>Nome Cliente</th>
                                                            <th>Fone Cliente</th>
                                                            <th>Data</th>
                                                            <th>Hora</th>
                                                            <th>Valor</th>
                                                            <th>Desconto</th>
                                                            <th>Valor Total</th>
                                                            <th>Nome Colaborador</th>
                                                            <th className="text-right">Status</th>
                                                            <th className="text-right">Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {agendamentos.map((agendamento, index) => (
                                                            <CardAgendamentos
                                                                key={`${agendamento.ID_RESERVA}-${index}`}
                                                                agendamento={{
                                                                    agendamento_id: agendamento.ID_RESERVA,
                                                                    agendamento_descricao: agendamento.DESCRICAO || 'Descrição indisponível',
                                                                    agendamento_nome: agendamento.AA_CLIENTE_NOME || 'Nome indisponível',
                                                                    agendamento_fone: agendamento.AA_CLIENTE_FONE || 'Telefone indisponível',
                                                                    agendamento_data: agendamento.DATA_RESERVA || 'Data indisponível',
                                                                    agendamento_hora: agendamento.HORA || 'Hora indisponível',
                                                                    agendamento_vr: agendamento.VALOR || 'Vr indisponível',
                                                                    agendamento_desc: agendamento.DESCONTO || 'R$ 0,00',
                                                                    agendamento_vrtot: agendamento.VALORTOTAL || 'Vr Tot indisponível',
                                                                    agendamento_nome_colaborador: agendamento.COL_NOME || 'Colaborador indisponível',
                                                                    agendamento_status: `${agendamento.ID_STATUS} : ${agendamento.ST_DESCRICAO || 'Status indisponível'}`
                                                                }}
                                                                showExcluir={true}
                                                                showAvaliar={false}
                                                                showMotivo={false}
                                                                showMudarStatus={false}
                                                                handleExcluir={handleExcluir}
                                                                tipoAtendimento={tipoAtendimento}
                                                            />
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                        )}
                                    </div>
                                    {hasMore && (
                                        <div className="load-more">
                                            <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button>
                                        </div>
                                    )}
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default PCMeusAgendamentos;